import mqtt from 'mqtt';
import { refreshAccessToken } from './OAuth2DeviceAuth';
const mqttQOS = 1;

const mqttBroker = `${process.env.REACT_APP_MQTT_BROKER}`;
const mqttGrantType = `${process.env.REACT_APP_MQTT_GRANT_TYPE}`;
const mqttClientID = 'joblog-publisher-' + Math.random().toString(16).substr(2, 8);

export function publishMqttMessage(
  topic: string,
  message: string[],
  filename: string,
  mqttUID: string,
  mqttPWD: string,
  refreshToken: boolean,
  rowNo: number,
) {
  // Set MQTT Broker connection options
  const options: mqtt.IClientOptions = {
    username: mqttUID,
    password: mqttPWD,
    clientId: mqttClientID,
  };

  // Connect to MQTT Broker
  try {
    const mqttClient = mqtt.connect(mqttBroker, options);

    mqttClient.on('connect', () => {
      console.log('*** Connected to MQTT broker');

      // Subscribe at startup
      //mqttClient.subscribe(topic, (err) => {
      //  if (!err) {
      //    console.log(`Subscribed to topic: ${topic}`);
      //  } else {
      //    console.error('Subscription error:', err);
      //  }
      //});

      // Publish message using to a max row count of 20,000 per transmission
      // EMQX MQTT max publish size = 1 MB.  A max of 256 MB can be configured.
      //const arrMsg = message.split('\n');
      let mqttPayload = '';
      let startRow = 0;
      let endRow = message.length - 1;

      //console.log('Start Row:', startRow);
      //console.log('End Row:', endRow);

      while (startRow <= endRow) {
        // Send slice of message array
        if (endRow - startRow >= 5000) {
          endRow = startRow + 4999;
        }
        const payloadSlice = message.slice(startRow, endRow + 1);
        for (let x = 0; x < payloadSlice.length; x++) {
          payloadSlice[x] =
            `{"streamId":"ef9e5f0f-4993-4077-bc70-64fca1b455e6", "streamName":"raw", "orgId":"dev-org", "eventData": {"data": {"ln_no": ` +
            rowNo +
            `, "raw": ` +
            JSON.stringify(payloadSlice[x]) +
            `}}}`;
          rowNo += 1;
        }
        mqttPayload = payloadSlice.join('\n');
        //console.log(`*** MQTT Payload Row:: ${mqttPayload}`);

        // Format payload for MQTT transmission
        //mqttPayload = `{`;
        //mqttPayload += `"metadata": {`
        //mqttPayload += `"m_type": "sentinel", "m_lns": ` + payloadSlice.length + `, `
        //mqttPayload += `"sn": "` + mqttUID + `", `
        //mqttPayload += `"fn": "` + filename + `"}, `
        //mqttPayload += `"data": [ ` + payloadSlice.join('\n,') + `]`;
        //mqttPayload += `}`;

        mqttClient.publish(topic, mqttPayload, { qos: mqttQOS }, err => {
          if (err) {
            console.error('*** Publish error:', err);
          } else {
            console.log(`*** Sent Rows: ${payloadSlice.length}  to ${topic}`);
          }
        });
        // Set next start and end rows for processing
        startRow = endRow + 1;
        endRow = message.length - 1;
      }

      //Disconnect from MQTT Broker
      if (mqttClient.connected) {
        mqttClient.end(false);
      }
    });

    // Subscription message received
    //mqttClient.on('message', (receivedTopic, message) => {
    //  // Message is a Buffer, convert to string
    //  const payload = message.toString();
    //  console.log(`Received Message: ${payload} from topic: ${receivedTopic}`);
    //});

    mqttClient.on('error', err => {
      if (err.message.includes('Bad username')) {
        // Refresh token if it has not already been attempted
        if (!refreshToken) {
          console.log('MQTT connection error:', err.message + ' (Refreshing access token)');
          // Call async function and make recursive call to this function if successful
          refreshAccessToken('refresh_token', mqttGrantType, localStorage.getItem('refreshToken') || '')
            .then(objResponse1 => {
              mqttClient.end(true);
              publishMqttMessage(
                topic,
                message,
                filename,
                mqttUID,
                localStorage.getItem('accessToken') || '',
                true,
                rowNo,
              );
            })
            .catch(err => {
              console.log('refreshToken Error: ', err.message);
            });
        } else {
          console.error('MQTT connection error:', err.message + ' (Unable to refresh access token)');
        }
      } else {
        console.error('MQTT connection error:', err.message);
      }

      if (mqttClient.connected) {
        mqttClient.end(true);
      }
    });

    mqttClient.on('close', () => {
      console.log('*** Disconnected from MQTT broker');
      return;
    });
  } catch (err: any) {
    console.error('MqttClient error:', err.message);
    return;
  }
}
